export const ENUM_CLAIM_UPLOAD_STATUS = {
  REVERSED: 'Reversed',
  LOADED: 'Loaded',
  INVALID_FILE: 'Invalid File',
  INVALID_FORMAT: 'Invalid Format'
} as const;
